import { fileExtension } from '../mediaViewer/mediaFileTypes';

export const DRAWIO_EXTENSIONS = new Set(['drawio', 'dio']);

export function isDrawioFile(fileName: string): boolean {
  return DRAWIO_EXTENSIONS.has(fileExtension(fileName));
}

/** Same-origin embed URL for the diagrams.net JSON postMessage protocol. */
export function buildDrawioEmbedSrc(basePath: string, viewOnly = false): string {
  const trimmed = basePath.replace(/\/+$/, '');
  const prefix = trimmed.length > 0 ? trimmed : '';
  const viewOptions = viewOnly
    ? '&chrome=0&lightbox=1&nav=1&layers=1&noSaveBtn=1&noExitBtn=1'
    : '';
  return `${prefix}/drawio-app/?embed=1&proto=json&spin=1&libraries=1${viewOptions}`;
}

export function drawioEmbedOrigin(): string {
  if (typeof window === 'undefined') return '';
  return window.location.origin;
}
